// Currency formatting for the dashboard. Shows the symbol BEFORE the amount
// for ZAR / USD / EUR / GBP (the common operational currencies); other codes
// fall back to "<CUR> 0.00" form.
//
// Examples:
//   formatCurrency(1500, "ZAR")  → "R 1,500.00"
//   formatCurrency(750.5, "USD") → "$ 750.50"
//   formatCurrency(40, "EUR")    → "€ 40.00"
//   formatCurrency(0, "ZWG")     → "ZWG 0.00"
//   formatCurrency(null)         → "—"

const SYMBOLS = {
  ZAR: "R",
  USD: "$",
  EUR: "€",
  GBP: "£",
  JPY: "¥",
  CNY: "¥",
};

export function formatCurrency(amount, currency) {
  if (amount === null || amount === undefined || amount === "") return "";
  const n = Number(amount);
  if (Number.isNaN(n)) return "";
  const cur = (currency || "ZAR").toUpperCase();
  const symbol = SYMBOLS[cur] || cur;
  const formatted = n.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${symbol} ${formatted}`;
}
